import type { SlugData, Technology } from '@indutrust/shared-model';

/**
 * Legacy technology catalog row — leaves live under `sub_technologies`
 * rather than the domain `capabilities` field.
 */
export type LegacyTechnology = {
  id: number;
  name: string;
  slug: string;
  capabilities?: SlugData[];
  capability_id?: number;
  sub_technologies?: SlugData[];
};

/**
 * Maps a legacy (or already-domain) technology catalog row so leaves are
 * always available as `capabilities`.
 */
export function legacyToTechnology(wire: unknown): Technology {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- catalog wire
  const row = wire as LegacyTechnology | Technology;
  const capabilities =
    row.capabilities ??
    ('sub_technologies' in row ? row.sub_technologies : undefined) ??
    [];
  return {
    id: row.id,
    name: row.name,
    slug: row.slug,
    capabilities: capabilities.map((leaf) => ({
      id: leaf.id,
      name: leaf.name,
      slug: leaf.slug,
    })),
  };
}
